// extracted by mini-css-extract-plugin
export default {"form":"form-s7Xa"};